import moment from "moment"
import MasterComponent from "../../../../../components/Forms"
import { MasterConfigs } from "../../../../../interfaces/entity"
import { Button, Drawer, Tag, message, Space, notification } from "antd"
import { CopyOutlined } from "@ant-design/icons"
import Report from "./Report/Report"
import React, { useEffect } from "react"
import { constants } from "../../../../../constants/common"
import { useDispatch } from "react-redux"
import { encryptData, decryptData } from "../../../../../actions/crypto"
import { getData } from "../../../../../actions/apiCall"

export const allLevels = [
    { name: "Test", value: constants.PROFILE_STATUS.TEST },
    { name: "Screening", value: constants.PROFILE_STATUS.SCREENING },
    { name: "Level 1", value: constants.PROFILE_STATUS.LEVEL_1 },
    { name: "Level 2", value: constants.PROFILE_STATUS.LEVEL_2 },
    { name: "Level 3", value: constants.PROFILE_STATUS.LEVEL_3 },
    { name: "Level 4", value: constants.PROFILE_STATUS.LEVEL_4 },
    { name: "Manager Round", value: constants.PROFILE_STATUS.MANAGER_ROUND },
    { name: "HR Round", value: constants.PROFILE_STATUS.HR_ROUND },
    { name: "Salary Discussion", value: constants.PROFILE_STATUS.SALARY_DISCUSSION },
    { name: "Pre onboarding", value: constants.PROFILE_STATUS.PREE_OWNBORDING },
    { name: "Genrate Offer", value: constants.PROFILE_STATUS.OFFER_GENRATE },
]
const AllTest = () => {
    const [isOpen, setIsOpen] = React.useState(false)
    const [selectedId, setSelectedId] = React.useState(null)
    const dispatch = useDispatch()

    const getTestLink = (testLinkId: string) => {
        if (!testLinkId) return null;
        const baseUrl = window.location.origin;
        const encryptedId = encryptData(testLinkId);
        return `${baseUrl}/instructions/${encryptedId}`;
    }

    const handleCopyTestLink = (testLinkId: string) => {
        const testLink = getTestLink(testLinkId);
        if (!testLink) {
            message.error('Test link not available');
            return;
        }
        navigator.clipboard.writeText(testLink).then(() => {
            message.success('Test link copied to clipboard!');
        }).catch(() => {
            message.error('Failed to copy test link');
        });
    }


    const config: MasterConfigs = {
        api: () => '/test-details',
        modalTitle: () => 'Test Details',
        getColumns: () => {
            return [
                {
                    title: 'Candidate Name',
                    dataIndex: 'candidate',
                    render: (text, record) => {
                        return <span>{record?.candidate?.firstName} {record?.candidate?.lastName}</span>
                    },
                },
                {
                    title: 'Current Round',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return <span>{allLevels.find(e => e.value == record?.candidate?.level)?.name}</span>
                    },
                },
                {
                    title: 'Level',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return record?.candidate?.candidateType
                    },
                },
                {
                    title: 'Test Name',
                    dataIndex: 'testConfig',
                    render: (text, record) => {
                        return record?.testConfig?.name
                    },
                },
                {
                    title: 'Link Sent At',
                    dataIndex: 'linkSentAt',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).format('lll')
                    },
                },
                {
                    title: 'Link Expired At',
                    dataIndex: 'linkExpiredAfter',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).add(record?.linkExpiredAfter, record?.expiredType).format('lll')
                    },
                },
                {
                    title: 'Status',
                    dataIndex: 'testStatus',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testStatus
                        const statusMap = {
                            'setup-in-progress': 'Setup In Progress',
                            'pending': 'Pending',
                            'completed': 'Completed',
                            'expired': 'Expired',
                            'inporgress': 'In Progress',
                            'failed': 'Failed'
                        }

                        // use Tag from antd to show status with color
                        const statusColorMap = {
                            'setup-in-progress': 'orange',
                            'pending': 'blue',
                            'completed': 'green',
                            'expired': 'red',
                            'inporgress': 'yellow',
                            'failed': 'red'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    },
                },
                {
                    title: 'Review Status',
                    dataIndex: 'testResult',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testResult
                        const statusMap = {
                            'Hold': 'Hold',
                            'Rejected': 'Rejected',
                            'Shortlisted': 'Shortlisted',
                            'In-Review': 'In-Review'
                        }
                        const statusColorMap = {
                            'Hold': 'orange',
                            'Rejected': 'red',
                            'Shortlisted': 'green',
                            'In-Review': 'blue'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    }
                },
                {
                    title: 'Test Link',
                    dataIndex: '_id',
                    align: 'center',
                    width: 120,
                    render: (text, record) => {
                        if (!record?.linkSentAt) {
                            return <span style={{ color: '#999' }}>Not sent</span>;
                        }
                        return (
                            <Button
                                type="link"
                                icon={<CopyOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyTestLink(record._id);
                                }}
                            >
                                Copy Link
                            </Button>
                        );
                    }
                },
                {
                    title: 'Action',
                    dataIndex: 'testStatus',
                    align: 'center',
                    width: 200,
                    render: (text, record) => {
                        if (record?.testStatus === 'completed' || record?.testStatus === 'inporgress') {
                            return (
                                <Button type="link" onClick={() => setSelectedId(record?._id)}>
                                    View Report
                                </Button>
                            )
                        }
                        return <></>
                    }
                }
            ]
        }
    }

    useEffect(() => {
        if (selectedId) {
            setIsOpen(true)
        }
    }, [selectedId])

    return (
        <>
            <MasterComponent config={config} />
            <Drawer
                open={isOpen}
                title={
                    <div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Report</div>
                        <div style={{ fontSize: '14px', color: '#8c8c8c', marginTop: '4px' }}>Overview</div>
                    </div>
                }
                onClose={() => {
                    setIsOpen(false);
                    setSelectedId(null);
                }}
                width={'90%'}
                styles={{
                    body: { padding: '24px', background: '#f5f5f5' }
                }}
            >
                <Report id={selectedId} />
            </Drawer>
        </>
    )
}

export default AllTest